import {NgModule} from '@angular/core';
import {CommonModule, PercentPipe} from '@angular/common';
import {HomeViewComponent} from './home-view/home-view.component';
import {HomeRoutingModule} from './home-routing.module';
import {LoanApplicationComponent} from './loan-application/loan-application.component';
import {EmploymentTypeComponent} from './loan-application/employment-type/employment-type.component';
import {
  MatAutocompleteModule,
  MatButtonModule, MatCardModule,
  MatDatepickerModule,
  MatFormFieldModule,
  MatInputModule, MatOptionModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSelectModule, MatToolbarModule, MatCheckboxModule,
} from '@angular/material';
import {FlexLayoutModule} from '@angular/flex-layout';
import {SliderInputModule} from '../@modules/slider-input/slider-input.module';
import {LoanRequestComponent} from './loan-application/loan-request/loan-request.component';
import {ReactiveFormsModule} from '@angular/forms';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {DatePickerModule} from '../@modules/date-picker/date-picker.module';
import {FullNameComponent} from './loan-application/personal-info/full-name/full-name.component';
import {ContactDetailsComponent} from './loan-application/personal-info/contact-details/contact-details.component';
import {LocationComponent} from './loan-application/personal-info/location/location.component';
import {BirthdateComponent} from './loan-application/personal-info/birthdate/birthdate.component';
import {CareerDatesComponent} from './loan-application/current-status/career-dates/career-dates.component';
import {EmploymentStateComponent} from './loan-application/current-status/employment-state/employment-state.component';
import {ReferenceComponent} from './loan-application/loan-info/reference/reference.component';
import {EmploymentInfoComponent} from './loan-application/employment-info/employment-info.component';
import {LandBasedComponent} from './loan-application/employment-info/land-based/land-based.component';
import {SeamanComponent} from './loan-application/employment-info/seaman/seaman.component';
import {PersonalInfoComponent} from './loan-application/personal-info/personal-info.component';
import {CurrentStatusComponent} from './loan-application/current-status/current-status.component';
import {LoanInfoComponent} from './loan-application/loan-info/loan-info.component';
import {RequestComponent} from './loan-application/loan-info/request/request.component';
import {CoMakerComponent} from './loan-application/loan-info/co-maker/co-maker.component';
import {BranchesComponent} from './loan-application/branches/branches.component';
import {ThankYouComponent} from './loan-application/thank-you/thank-you.component';
import {LoanApplicationDBService} from '../@db/loan-application-db.service';
import {ContactDBService} from '../@db/contact-db.service';
import {LoanApplicationService} from './loan-application/loan-application.service';
import {EmploymentStateDBService} from '../@db/employment-state-db.service';
import {CountrySelectService} from '../@modules/country-select/country-select.service';
import {JobTitleFieldModule} from '../@modules/job-title-field/job-title-field.module';
import {JobTitleService} from '../@modules/job-title-field/job-title.service';
import {AgencyFieldModule} from '../@modules/agency-field/agency-field.module';
import {AgencyDBService} from '../@db/agency-db.service';
import {TermsAndConditionsFieldComponent} from './loan-application/terms-and-conditions/terms-and-conditions-field.component';
import {CareerDetailsComponent} from './loan-application/current-status/career-details/career-details.component';
import {NumberComponent} from './loan-application/number/number.component';
import {PageOneComponent} from './loan-application/page-one/page-one.component';
import {PageTwoComponent} from './loan-application/page-two/page-two.component';
import {PageZeroComponent} from './loan-application/page-zero/page-zero.component';
import {ResponsiveImageModule} from '../@modules/responsive-image/responsive-image.module';
import {ContentBackDropModule} from '../@contents/@common/back-drop/content-back-drop.module';
import {BannerModule} from '../@banner/banner.module';
import {SeamanLoanModule} from './seaman-loan/seaman-loan.module';
import {OfwLoanModule} from './ofw-loan/ofw-loan.module';
import {OfwStatusSelectService} from '../@modules/ofw-status-select/ofw-status-select.service';
import {JobCategorySelectService} from '../@modules/job-category-select/job-category-select.service';
import {SuffixSelectService} from '../@modules/suffix-select/suffix-select.service';
import {ProvinceSelectService} from '../@modules/province-select/province-select.service';
import {CitySelectService} from '../@modules/city-select/city-select.service';
import {ApplicationSourceSelectService} from '../@modules/application-source-select/application-source-select.service';

@NgModule({
  imports: [
    CommonModule,
    HomeRoutingModule,
    MatButtonModule,
    FlexLayoutModule,
    SliderInputModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatMomentDateModule,
    DatePickerModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatToolbarModule,
    JobTitleFieldModule,
    MatAutocompleteModule,
    MatOptionModule,
    AgencyFieldModule,
    MatCheckboxModule,
    ResponsiveImageModule,
    ContentBackDropModule,
    BannerModule,
    SeamanLoanModule,
    OfwLoanModule,
  ],
  declarations: [
    HomeViewComponent,
    LoanApplicationComponent,
    EmploymentTypeComponent,
    LoanRequestComponent,
    FullNameComponent,
    ContactDetailsComponent,
    LocationComponent,
    BirthdateComponent,
    CareerDatesComponent,
    EmploymentStateComponent,
    ReferenceComponent,
    EmploymentInfoComponent,
    LandBasedComponent,
    SeamanComponent,
    PersonalInfoComponent,
    CurrentStatusComponent,
    LoanInfoComponent,
    RequestComponent,
    CoMakerComponent,
    BranchesComponent,
    ThankYouComponent,
    TermsAndConditionsFieldComponent,
    CareerDetailsComponent,
    NumberComponent,
    PageOneComponent,
    PageTwoComponent,
    PageZeroComponent,
  ],
  providers: [
    LoanApplicationService,
    ContactDBService,
    EmploymentStateDBService,
    CountrySelectService,
    LoanApplicationDBService,
    PercentPipe,
    JobTitleService,
    AgencyDBService,
    OfwStatusSelectService,
    JobCategorySelectService,
    SuffixSelectService,
    ProvinceSelectService,
    CitySelectService,
    ApplicationSourceSelectService,
  ],
})
export class HomeModule {
}
